(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biomarkers-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initBiomarkersFooterDisclaimers() {
      const disclosures = document.querySelectorAll('[data-biomarkers-footer-disclaimers]');

      for (const disclosure of disclosures) {
        const extra = disclosure.querySelector('[data-biomarkers-footer-disclaimer-extra]');
        const preview = disclosure.querySelector('[data-biomarkers-footer-disclaimer-preview]');
        const toggle = disclosure.querySelector('[data-biomarkers-footer-disclaimer-toggle]');

        if (
          !(extra instanceof HTMLElement) ||
          !(preview instanceof HTMLElement) ||
          !(toggle instanceof HTMLButtonElement)
        ) {
          continue;
        }

        if (toggle.dataset.biomarkersFooterDisclosureInitialized === 'true') continue;

        toggle.dataset.biomarkersFooterDisclosureInitialized = 'true';
        preview.hidden = false;
        extra.hidden = true;
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const shouldExpand = !isExpanded;

          preview.hidden = shouldExpand;
          extra.hidden = !shouldExpand;
          toggle.setAttribute('aria-expanded', String(shouldExpand));
          toggle.textContent = shouldExpand ? 'Show Less' : 'Read More';
        });
      }
    }

    initBiomarkersFooterDisclaimers();
    document.addEventListener('shopify:section:load', initBiomarkersFooterDisclaimers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-glp1-hero"] && !Shopify.designMode) return;
  try {
    
  const heroCta = document.querySelector('.rx-glp1-hero__cta');
  const header = document.querySelector('.immortals-header');

  if (heroCta instanceof HTMLAnchorElement && heroCta.href && header) {
    const href = heroCta.href;
    const label = heroCta.textContent.trim() || 'Get Started';

    const applyHref = (link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      link.href = href;
      link.setAttribute('data-cta-destination', href);
    };

    const existingLinks = header.querySelectorAll(
      '.immortals-header__cta, [data-cta-id="dynamic-header-primary-cta"], [data-cta-id="dynamic-mobile-drawer-primary-cta"]'
    );

    for (const link of existingLinks) {
      applyHref(link);
    }

    if (!header.querySelector('.immortals-header__cta')) {
      const columns = header.querySelector('.header__columns');

      if (columns) {
        const headerCta = document.createElement('a');
        headerCta.className = 'immortals-header__cta focus-inset';
        headerCta.textContent = label;
        headerCta.dataset.segmentCta = '';
        headerCta.dataset.segmentOutbound = '';
        headerCta.dataset.ctaId = 'rx-glp1-header-primary';
        headerCta.dataset.ctaLabel = label;
        headerCta.dataset.ctaLocation = 'header';
        headerCta.dataset.ctaTier = 'primary';
        headerCta.dataset.ctaVariant = 'header';
        applyHref(headerCta);
        columns.append(headerCta);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-sex-complex-hero"] && !Shopify.designMode) return;
  try {
    
  // The theme header renders no CTA on this template (the dynamic header
  // blanks `cta_label` when no metaobject entry matches), but the design's nav
  // always shows "Get Started". Mirror `rx-glp1-hero.liquid`: point any
  // existing header CTA at the hero's destination, and create one if absent.
  const heroCta = document.querySelector('.rx-sex-complex-hero__cta');
  const header = document.querySelector('.immortals-header');

  if (heroCta instanceof HTMLAnchorElement && heroCta.href && header) {
    const href = heroCta.href;
    const label = heroCta.textContent.trim() || 'Get Started';

    const applyHref = (link) => {
      if (!(link instanceof HTMLAnchorElement)) return;

      link.href = href;
      link.setAttribute('data-cta-destination', href);
    };

    const existingLinks = header.querySelectorAll(
      '.immortals-header__cta, [data-cta-id="dynamic-header-primary-cta"], [data-cta-id="dynamic-mobile-drawer-primary-cta"]'
    );

    for (const link of existingLinks) {
      applyHref(link);
    }

    if (!header.querySelector('.immortals-header__cta')) {
      const columns = header.querySelector('.header__columns');

      if (columns) {
        const headerCta = document.createElement('a');
        headerCta.className = 'immortals-header__cta focus-inset';
        headerCta.textContent = label;
        headerCta.dataset.segmentCta = '';
        headerCta.dataset.segmentOutbound = '';
        headerCta.dataset.ctaId = 'rx-sex-complex-header-primary';
        headerCta.dataset.ctaLabel = label;
        headerCta.dataset.ctaLocation = 'header';
        headerCta.dataset.ctaTier = 'primary';
        headerCta.dataset.ctaVariant = 'header';
        applyHref(headerCta);

        // The group wrapper is what `rx-sex-complex-header.scss` pins to the
        // right of the pill; a bare anchor falls into the header grid flow.
        const ctaGroup = header.querySelector('.immortals-header__cta-group')
          ?? columns.appendChild(document.createElement('div'));
        ctaGroup.classList.add('immortals-header__cta-group');
        ctaGroup.append(headerCta);
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
